export enum LABEL_VARIANTS {
  ACTIVE = 'Active',
  SUSPENDED = 'Suspended',
  REGISTERED = 'Registered',
  PENDING = 'Pending',
  DEFAULT = 'Default',
  CLOSE = 'Close',
}
